import Typography, { type TypographyProps } from "@mui/material/Typography";

/** A muted, secondary body paragraph — supporting copy, fine print, asides. */
export function Note(props: TypographyProps) {
  return <Typography variant="body2" color="text.secondary" {...props} />;
}
